import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { ProjectsStepUi } from "@src/widgets/onboarding/ui/tours/ApiIntegration/ProjectsStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class ProjectsStep extends TourStepBase {
  component = ProjectsStepUi
  name = `${ONBOARDING_TOURS.API_INTEGRATION}_Projects`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_CREATEBUTTON_BUTTON_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.TOP_LEFT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.projects,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "It all begins here",
      title: "Projects",
    }
  }
}
